import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import HomePage    from './pages/HomePage';
import DepotPage   from './pages/DepotPage';
import LoginPage   from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import DashboardPage from './pages/DashboardPage';
import AgentPage from './pages/AgentPage';
import SuiviPage   from './pages/SuiviPage';
import ColisDetailsPage from './pages/ColisDetailsPage';
import MesColisPage from './pages/MesColisPage';
import MesValisesPage from './pages/MesValisesPage';
import ComptePage from './pages/ComptePage';
/* SUIVI EN DIRECT (pause)
import LivreurLivePage from './pages/LivreurLivePage';
*/
import ColisContext from './data/ColisContext';
import RequireAuth from './components/RequireAuth';
import RequireAdmin from './components/RequireAdmin';
import RequireAgent from './components/RequireAgent';
import ErrorBoundary from './components/ErrorBoundary';

export default function App() {
  return (
    <ErrorBoundary>
      <ColisContext>
        <BrowserRouter>
          <Routes>
            <Route path="/"         element={<HomePage />} />
            <Route path="/express"  element={<HomePage />} />
            <Route path="/dashboard" element={<RequireAuth><DashboardPage /></RequireAuth>} />
            <Route path="/express/dashboard" element={<RequireAuth><DashboardPage /></RequireAuth>} />
            <Route path="/login"    element={<LoginPage />} />
            <Route path="/express/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/express/register" element={<RegisterPage />} />
            <Route path="/depot"    element={<RequireAuth><DepotPage /></RequireAuth>} />
            <Route path="/express/depot" element={<RequireAuth><DepotPage /></RequireAuth>} />
            <Route path="/admin" element={<RequireAdmin><DashboardPage /></RequireAdmin>} />
            <Route path="/express/admin" element={<RequireAdmin><DashboardPage /></RequireAdmin>} />
            <Route path="/agent" element={<RequireAgent><AgentPage /></RequireAgent>} />
            <Route path="/express/agent" element={<RequireAgent><AgentPage /></RequireAgent>} />
            <Route path="/mes-colis" element={<RequireAuth><MesColisPage /></RequireAuth>} />
            <Route path="/express/mes-colis" element={<RequireAuth><MesColisPage /></RequireAuth>} />
            <Route path="/mes-valises" element={<RequireAuth><MesValisesPage /></RequireAuth>} />
            <Route path="/express/mes-valises" element={<RequireAuth><MesValisesPage /></RequireAuth>} />
            <Route path="/compte" element={<RequireAuth><ComptePage /></RequireAuth>} />
            <Route path="/express/compte" element={<RequireAuth><ComptePage /></RequireAuth>} />
            <Route path="/suivi"    element={<SuiviPage />} />
            <Route path="/express/suivi" element={<SuiviPage />} />
            <Route path="/details"  element={<ColisDetailsPage />} />
            <Route path="/express/details" element={<ColisDetailsPage />} />
            <Route path="*"         element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </ColisContext>
    </ErrorBoundary>
  );
}
